import { PHONE_LENGTH, fieldNames, defaultValues } from './constants';

export const normalizePhone = (value = '') => {
  let digits = value.replace(/\D/g, '');

  if (digits.length > PHONE_LENGTH && /^[78]/.test(digits)) {
    digits = digits.slice(1);
  }

  return digits.slice(0, PHONE_LENGTH);
};

export const formatPhone = (digits = '') =>
  digits
    .replace(/^(\d{1,3})/, '($1')
    .replace(/^(\(\d{3})(\d{1,3})/, '$1) $2')
    .replace(/(\s\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})(\d{1,2})$/, '$1-$2');

export const countDigitsBeforeIndex = (value, index) =>
  (value.slice(0, index).match(/\d/g) || []).length;

export const getCursorPositionForDigitCount = (formatted, digitCount) => {
  if (digitCount <= 0) return 0;

  let seen = 0;

  for (let i = 0; i < formatted.length; i++) {
    if (/\d/.test(formatted[i])) {
      seen++;
      if (seen === digitCount) return i + 1;
    }
  }

  return formatted.length;
};

const trim = (value) => value?.trim() || undefined;

export const createClientPayload = (values, existingClientId) => {
  const surName = trim(values[fieldNames.surName]);
  const firstName = trim(values[fieldNames.firstName]);
  const patrName = trim(values[fieldNames.patrName]);

  const payload = {
    surName,
    firstName,
    patrName,
    fio: [surName, firstName, patrName].filter(Boolean).join(' '),
    phone: values[fieldNames.phone],
    email: trim(values[fieldNames.email]) || '',
    isOwner: values[fieldNames.isOwner],
  };

  if (existingClientId) {
    payload.id = existingClientId;
  }

  return payload;
};

export const getInitialValues = (tenant) => {
  if (!tenant) return defaultValues;

  return {
    [fieldNames.surName]: tenant.surName ?? '',
    [fieldNames.firstName]: tenant.firstName ?? '',
    [fieldNames.patrName]: tenant.patrName ?? '',
    [fieldNames.phone]: normalizePhone(tenant.phone ?? ''),
    [fieldNames.email]: tenant.email ?? '',
    [fieldNames.isOwner]: tenant.isOwner ?? true,
  };
};
